import { FindFormatCommand, FormatVO, PermissionAccess, PermissionVisibility, StaticFeatureEnum, StyleVO } from '@wizeoo/akm-common-lib';
import { BATCH_KIND } from '@wizeoo/akm-common-lib';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { CONFIRMATION_MODE, CONFIRMATION_RESULT, WizMathUtils, WizStringUtils, WIZ_EVENT_TYPE } from '@wizeoo/akm-core-lib';
import {
  ConfirmationResultObj,
  FilterComponent,
  WizDatasource,
  WizDropdown,
  WizGroupCommand,
  WizPopUp,
  WizRoot,
  WizTextInput,
  WizTranslationBasic,
  WizValidationContainerDirective,
  WizValidationError,
  WizValidationErrors,
  WizValidatorFn,
  WizVgroup,
  WizIcon,
  WizEventManager, WizEvent
} from '@wizeoo/akm-component-lib';
import { MultiDisplay, MultiDisplayConfig } from '@wizeoo/akm-common-lib';
import { AlkEvent } from '@wizeoo/akm-common-lib';
import { ALK_EVENT_TYPE } from '@wizeoo/akm-common-lib';
import { Model } from 'src/app/model/model';
import { ViewData } from '@wizeoo/akm-common-lib';
import { FakeVO } from '@wizeoo/akm-common-lib';
import { BaseView } from '@wizeoo/akm-common-lib';
import { FormatLockRenderer } from './format-lock.renderer';
import { EM_ACTION } from '@wizeoo/akm-compute-lib';
/**
 * Vue de gestion des includes / excludes
 * Author LMA
 */
@Component({
  selector: 'format-view',
  templateUrl: './format.view.html',
})
export class FormatView extends BaseView {
  @ViewChild('mdMain') mdMain: MultiDisplay<StyleVO>; // grid principal

  @ViewChild('tiCode', { read: WizTextInput }) tiCode: WizTextInput; // champ de saisie du code
  @ViewChild('tiVisionCode', { read: WizTextInput }) tiVisionCode: WizTextInput; // champ d'affichage de la vision
  /** Composant de saisie de la description */
  @ViewChild('trsLabel', { read: WizTranslationBasic }) trsLabel: WizTranslationBasic;
  @ViewChild('trsDesc', { read: WizTranslationBasic }) trsDesc: WizTranslationBasic;

  @ViewChild('vgEdition', { read: WizVgroup }) vgEdition: WizVgroup; // ensemble de la zone de détail pour écoute ModelUpdate
  @ViewChild('vgEdition', { read: WizValidationContainerDirective, static: false })
  private vgEditionCheck: WizValidationContainerDirective; // Zone de validation globale

  @ViewChild('tiRegExp', { read: WizTextInput }) tiRegExp: WizTextInput; // champ de saisie de la regexp
  @ViewChild('ddFormat', { read: WizDropdown }) ddFormat: WizDropdown; // type de format (int / number / date)

  /** Bouton d'ajout */
  @ViewChild('btnCreate', { read: WizIcon }) btnCreate: WizIcon;
  /** Bouton d'export */
  @ViewChild('btnExport', { read: WizIcon, static: false }) btnExport: WizIcon;
  /** Bouton d'import */
  @ViewChild('btnImport', { read: WizIcon, static: false }) btnImport: WizIcon;
  /** Bouton de suppression */
  @ViewChild('btnRemove', { read: WizIcon, static: false }) btnDelete: WizIcon;

  public currentFormat: FormatVO = null; // sélection active (objet métier vrai)
  public clone: FormatVO = null; // clone de travail

  /** pas d'édition des formats de base */
  public get isRootFormat(): boolean {
    return !!this.currentFormat && this.currentFormat.basicFormat;
  }

  /** Constructeur */
  constructor(public elementRef: ElementRef) {
    super(elementRef);
  }

  /** DS du grid principal */
  public mainDS: WizDatasource<FormatVO> = new WizDatasource<FormatVO>([])
    .setSortFields([{ property: 'code', way: 'asc', numeric: false }])
    .setSelectionMode('single')
    .build();

  /** DS de la drop de types de données */
  public datatypeDS: WizDatasource<FakeVO> = new WizDatasource<FakeVO>(ViewData.getInstance().datatypeList)
    // .setItemCodeField('dataKind')
    .setSortFields([{ property: 'order', way: 'asc' }])
    .build();

  /** Configuration du mode multi display (principal) */
  public mainConfig: MultiDisplayConfig<FormatVO> = {
    model: Model.getInstance(),
    datasource: this.mainDS,
    defaultMode: 'grid',
    onSelectionChanging: this.askSelectMain.bind(this),
    grid: {
      enabled: true,
      columns: [
        { headerName: ' ', width: 40, sortable: true, field: 'basicFormat', cellRenderer: 'lockRenderer' },
        { headerName: '$.common.code.$', width: 80, sortable: true, field: 'code', tooltipField: 'code' },
        { headerName: '$.common.regexp.$', flex: 1, sortable: true, field: 'regExp', tooltipField: 'regExp' },
      ],
      renderers: {
        lockRenderer: FormatLockRenderer,
      },
    },
    filter: {
      enabled: true,
      initFilter: this.initMainFilter.bind(this),
    },
  };

  /* #############################################################
                      CYCLE DE VIE
     ############################################################# */

  /**
   * Pretraitement: chargement des données nécessaires à la vue
   * @return WizGroupCommand
   */
  public wizBeforeInit(): WizGroupCommand {
    super.wizBeforeInit();
    const commands = [];
    // chargement de la liste des formats
    if (!Model.getInstance().formatEngine.getFormatList()) {
      // double appel pour format de base à la bu (*)
      commands.push(new FindFormatCommand(Model.getInstance()).find(ViewData.wildcardDomain, ViewData.wildcardDomain));
      commands.push(new FindFormatCommand(Model.getInstance()).find(Model.getInstance().domainCode, Model.getInstance().businessUnitCode));
    }

    if (commands.length > 0) {
      return new WizGroupCommand().configure(commands, null, false);
    } else {
      return null;
    }
  }

  /**
   * Synchronisation des données
   */
  public wizSynchronizeData(): void {

    super.managePermissions([
      {
        feature: StaticFeatureEnum.FORMAT,
        permissions: [
          {
            component: this.btnCreate,
            accesses: [PermissionAccess.CREATE],
            visibility: PermissionVisibility.DISABLED,
          },
          {
            component: this.btnDelete,
            accesses: [PermissionAccess.DELETE],
            visibility: PermissionVisibility.DISABLED,
          },
          {
            component: this.btnExport,
            accesses: [PermissionAccess.BATCH],
            visibility: PermissionVisibility.DISABLED,
          },
          {
            component: this.btnImport,
            accesses: [PermissionAccess.BATCH],
            visibility: PermissionVisibility.DISABLED,
          },
        ],
      },
    ]);

    this.mainFilter.configure(['code', 'regExp'], null, null); // alimentation du filtre principal
    this.mainDS.setSource(Model.getInstance().formatEngine.getFormatList()); // alimentation de la liste principale
    this.tiCode.wizRestrict = ViewData.CODE_REGEXP;
    this.ddFormat.wizDataProvider = this.datatypeDS; // alimentation de la drop des types de données
    // TODO collecte du contexte pour currentStyle
    this.feed();
  }

  /** alimentation de la zone de détail */
  private feed(): void {
    // TODO ici gestion des permissions

    this.vgEdition.visible = !!this.clone;

    if (!!this.clone) {
      this.tiCode.wizValue = this.clone.code; // alimentation du code
      this.trsLabel.translationData = Model.getInstance().localeEngine.buildTranslationData(this.clone.labelVO);
      this.trsDesc.translationData = Model.getInstance().localeEngine.buildTranslationData(this.clone.descriptionVO);

      this.tiRegExp.wizValue = this.clone.regExp; // alimentation du format
      let st: FakeVO = null; // le statut en forme "objet"
      if (this.clone.dataKind) {
        st = this.datatypeDS.getItemByKey(this.clone.dataKind);
      }
      this.datatypeDS.select([st]);

      if (this.clone.exist) {
        this.tiCode.wizDisabled = true;
      } else {
        this.tiCode.wizDisabled = false;
        setTimeout(() => {
          // sinon, pas le temps de rendre les compos enabled
          this.tiCode.wizFocus();
        }, 0);
      }
    }
  }

  /** Mise en place des ecouteurs de la vue */
  public wizAddListener(): void {
    super.wizAddListener();
    WizEventManager.addListener(this, this.vgEdition, WIZ_EVENT_TYPE.MODEL_UPDATE, this.updateModel); // écouteur global change pour modelUpdate
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.BATCH_IMPORT_RETURN, this.backFromImport);
  }

  /**
   * Suppression des ecouteurs de la vue
   */
  public wizRemoveListener(): void {
    super.wizRemoveListener();
    WizEventManager.removeListener(this, this.vgEdition, WIZ_EVENT_TYPE.MODEL_UPDATE);
    WizEventManager.removeListener(this, WizRoot.root(), ALK_EVENT_TYPE.BATCH_IMPORT_RETURN);
  }

  /** fonction de suppression du format */
  public mayDelete(): boolean {
    return !this.cantDelete || (!!this.currentFormat && this.currentFormat.domain !== ViewData.wildcardDomain);
  }

  /** desactivation des boutons save et cancel sur updateModel */
  public disableButtons(): boolean {
    return !ViewData.wizUpdateModel;
  }

  /* #############################################################
                  gestion sélection et filtres
     ############################################################# */

  private mainFilter: FilterComponent; // filterCompo du mdMain
  /** init du filter du mdMain */
  private initMainFilter(pFilter: FilterComponent): FilterComponent {
    this.mainFilter = pFilter;
    return this.mainFilter;
  }

  /** demande de changement de sélection */
  private askSelectMain(e: WizEvent = null): void {
    const vo: FormatVO = e.value;
    if (ViewData.wizUpdateModel) {
      // if (this.mainDS.isSelected(vo)) { // sélection self, rien
      //   e.preventDefault();
      //   return;
      // }
      e.preventDefault(); // sélection pas self && modifs en cours

      WizPopUp.confirm(
        '$.common.pending.update.title.$',
        '$.common.pending.update.detail.$',
        this.confirmSelect.bind(this),
        CONFIRMATION_MODE.CONFIRM_CANCEL,
        vo,
        null,
        null
      ).show();
    } else {
      if (!this.mainDS.isSelected(vo)) {
        // pas encore sélectionné
        this.doSelect(vo);
      } else {
        // déjà sélectionné, déselection
        this.doSelect(null);
      }
    }
  }

  /**
   * Confirmation de la sélection du FormatVO
   */
  private confirmSelect(result: ConfirmationResultObj): void {
    if (result.result === CONFIRMATION_RESULT.CONFIRM) {
      const vo: FormatVO = result.data;
      this.mainDS.toggle(vo); // on a prevent l'event, on joue l'action
      this.doSelect(vo);
    }
  }

  /**
   * Changement de FormatVO sélectionné
   * @param pEvent WizEvent
   */
  private doSelect(vo: FormatVO) {
    ViewData.wizUpdateModel = false;
    if (vo) {
      this.currentFormat = vo;
      this.clone = Model.getInstance().formatEngine.clone(this.currentFormat);
    } else {
      this.currentFormat = null;
      this.clone = null;
    }
    this.feed();
  }

  /**
   * Changement de FormatVO sélectionné
   * @param pEvent WizEvent
   */
  public doCancel() {
    ViewData.wizUpdateModel = false;
    this.clone = Model.getInstance().formatEngine.clone(this.currentFormat);
    this.feed();
  }

  public doAct(action: string): void {
    switch (action) {
      case 'export':
        Model.getInstance().batchEngine.export(BATCH_KIND.FORMAT);
        break;
      case 'import':
        Model.getInstance().batchEngine.import(BATCH_KIND.FORMAT);
        break;
    }
  }

  /** callback sur retour d'import : recharger les Freedatas */
  private backFromImport(e: AlkEvent): void {
    // Juste besoin de rafraichir les données spécifiques au domain/bu courant
    if (e && e.data === BATCH_KIND.FORMAT) {
      new FindFormatCommand(Model.getInstance()).find(Model.getInstance().domainCode, Model.getInstance().businessUnitCode).configure(this.backFromReload.bind(this)).execute();
    }
  }

  private backFromReload(e: any): void {
    this.wizSynchronizeData();
  }

  /** création nouveau style */
  public askForAdd(): void {
    this.currentFormat = Model.getInstance().formatEngine.buildFake();
    this.clone = Model.getInstance().formatEngine.clone(this.currentFormat);
    this.mainDS.clearSelection();
    this.feed();
  }

  /** demande de suppression */
  public askForDelete(): void {
    WizPopUp.confirm(
      '$.common.delete.title.$',
      '$.common.delete.detail.$',
      this.doRemove.bind(this),
      CONFIRMATION_MODE.CONFIRM_CANCEL,
      this.currentFormat
    ).show();
  }

  /**
   * Suppression
   * @param result Objet de retour sur popUp de confirmation. Contient l'action choisie, et la data d'origine
   */
  private doRemove(result: ConfirmationResultObj): void {
    if (result.result === CONFIRMATION_RESULT.CONFIRM) {
      Model.getInstance().formatEngine.remove(this.clone, this.currentFormat, this.backFromMerge.bind(this));
    }
  }

  /**
   * Validateur d'unicité du code / shortCode
   */
  public uniqueCodeValidator(): WizValidatorFn {
    return (): WizValidationErrors | null => {
      // Pas de gestion d'erreur si le _clone est null
      if (!this.clone) {
        return null;
      }
      if (this.tiCode.wizValue !== null && this.tiCode.wizValue && this.tiCode.wizValue.length > 0) {
        // CHRONO = mot réservé
        if (this.tiCode.wizValue.toUpperCase() === 'CHRONO') {
          const temp: WizValidationError = {
            wizError: '$.common.keyword.$',
            wizErrorParams: [],
          };
          return [temp];
        }

        // Recherche d'une autre style avec le même code
        let otherStyle: FormatVO = null;
        if (Model.getInstance().formatEngine.getFormatMap().has(this.clone.businessUnitCode)) {
          // check map existe
          otherStyle = Model.getInstance().formatEngine
            .getFormatMap().get(this.clone.businessUnitCode)
            .get(this.tiCode.wizValue.toUpperCase());
        }

        // Si un style existe deja avec le meme code on affiche le message
        if (otherStyle && otherStyle.uid !== this.clone.uid) {
          const temp: WizValidationError = {
            wizError: '$.format.error.code.unique.$',
            wizErrorParams: [],
          };
          return [temp];
        }
      }
      return null;
    };
  }

  /**
   * modification d'un élément de modèle
   * @param e WizEvent
   */
  private updateModel(e: WizEvent): void {
    switch (e.component) {
      case this.tiCode:
        const text: string = this.tiCode.wizValue;
        if (!WizStringUtils.isEmpty(text)) {
          // this.tiCode.setWizValueWithCaretPosition(text.toUpperCase());
        }
        this.clone.code = text.toUpperCase();
        break;
      case this.trsLabel:
        this.clone.labelVO.updateTranslationEntry(e.value);
        this.clone.maintenanceFlag = WizMathUtils.createUUID(); // PATCH MAJ SUBCOLL
        break;
      case this.trsDesc:
        this.clone.descriptionVO.updateTranslationEntry(e.value);
        this.clone.maintenanceFlag = WizMathUtils.createUUID(); // PATCH MAJ SUBCOLL
        break;
      case this.tiRegExp:
        this.clone.regExp = this.tiRegExp.wizValue;
        break;
      case this.ddFormat:
        this.clone.dataKind = this.ddFormat.selectedItem?.code;
        break;
      // default: // interception des mauvais update
      //   return;
    }
    this.clone.maintenanceFlag = WizMathUtils.createUUID(); // forcer l'update sur modif de children
    WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, true));
  }

  /** persistence sur save */
  public doMerge(): void {
    const errors = this.vgEditionCheck.check(true, true);
    if (!errors || (!!errors && errors.length === 0)) {
      Model.getInstance().formatEngine.merge(this.clone, this.currentFormat, this.backFromMerge.bind(this));
    } else {
      WizPopUp.toast('$.common.toast.pending.error.$', WizIcon.TOAST_ERROR).show();
    }
  }

  /**
   * Callback sur retour de persistence
   * @param bddBack style créé ou modifié ou supprimé
   * @param operation CUD
   */
  private backFromMerge(vo: FormatVO, operation: EM_ACTION): void {

    // if (operation === EM_ACTION.CREATE) {
    //   this.mainDS.addItem(vo);
    // } else if (operation === EM_ACTION.DELETE) {
    //   this.mainDS.removeItem(vo);
    // }
    this.mainDS.refresh();
    this.mainDS.clearSelection();
    this.currentFormat = null;
    this.clone = null;
    this.feed();
  }

  /**
   * Est-ce que l'utilisateur peut créer ?
   * @returns 
   */
  public get cantCreate(): boolean {
    return !Model.getInstance().permissionEngine.canCreate(StaticFeatureEnum.FORMAT);
  }

  /**
   * Est-ce que l'utilisateur peut mettre à jour ?
   * @returns 
   */
  public get cantUpdate(): boolean {
    return !Model.getInstance().permissionEngine.canUpdate(StaticFeatureEnum.FORMAT);
  }

  /**
   * Est-ce que l'utilisateur peut mettre à jour ?
   * @returns 
   */
  public get cantDelete(): boolean {
    return !Model.getInstance().permissionEngine.canDelete(StaticFeatureEnum.FORMAT);
  }

}
